import React, { useReducer, createContext } from 'react'

const ClearTheChartsContext = createContext(null)

const ClearTheChartsConsumer = ClearTheChartsContext.Consumer

const defaultState = {
  userStats: {},
  preflopCharts: {},
  currentChartProgress: {},
}

const unescape = (string) => {
  if (!string) return {}
  const stringWithoutEscape = string.replace(/\\/g, '')
  const obj = JSON.parse(stringWithoutEscape)
  return obj
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'set-active-shart-stats':
      const { chart } = action.payload
      return {
        ...state,
        chartStatsToShow: chart,
      }

    case 'reset-current-chart-progress': {
      const { chartId } = action.payload

      return {
        ...state,
        currentChartProgress: {
          ...state.currentChartProgress,
          [chartId]: {
            completedHands: {},
            mistakenHands: {},
          },
        },
      }
    }

    case 'set-sweeper-chart-completed': {
      const { chartId } = action.payload

      const chartStats = state.userStats[chartId] || {}
      const chartWins = chartStats.wins || 0

      return {
        ...state,
        userStats: {
          ...state.userStats,
          [chartId]: {
            ...chartStats,
            wins: 1 + parseInt(chartWins),
            chartId
          },
        },
      }
    }

    case 'fix-chart-hand-mistake': {
      const { chartId, hand } = action.payload
      const chartMistakesData =
        { ...state.sweeperUserStats.activeMistakes[chartId] } || {}
      delete chartMistakesData[hand]

      const fixedMistakesData =
        state.sweeperUserStats.fixedMistakes[chartId] || {}

      return {
        ...state,
        sweeperUserStats: {
          ...state.sweeperUserStats,
          activeMistakes: {
            [chartId]: {
              ...chartMistakesData,
            },
          },
          fixedMistakes: {
            [chartId]: {
              ...fixedMistakesData,
              [hand]: true,
            },
          },
        },
      }
    }

    case 'set-preflop-charts': {
      const data = action.payload

      const preflopChartsData = data.reduce((acc, curr) => {
        const { id } = curr
        return { ...acc, [id]: curr }
      }, {})

      return {
        ...state,
        preflopCharts: preflopChartsData,
      }
    }

    case 'set-user-sweeper-hand': {
      const { chartId, hand, isMistake } = action.payload

      const chartData = state.userStats[chartId] || {
        completedHandsAllTime: {},
        mistakenHandsAllTime: {},
        activeMistakes: {},
      }
      const currentChartProgressData = state.currentChartProgress[chartId] || {
        completedHands: {},
        mistakenHands: {},
      }

      const {
        mistakenHandsAllTime,
        completedHandsAllTime,
        activeMistakes,
      } = chartData

      const { completedHands, mistakenHands } = currentChartProgressData

      const userStatsToSet = {
        completedHandsAllTime: {
          ...completedHandsAllTime,
          [hand]: (completedHandsAllTime[hand] || 0) + 1,
        },
      }
      const currentChartProgressToSet = {
        ...currentChartProgressData,
        completedHands: {
          ...completedHands,
          [hand]: (completedHands[hand] || 0) + 1,
        },
      }

      if (isMistake) {
        userStatsToSet.mistakenHandsAllTime = {
          ...mistakenHandsAllTime,
          [hand]: (mistakenHandsAllTime[hand] || 0) + 1,
        }
        userStatsToSet.activeMistakes = {
          ...activeMistakes,
          [hand]: (activeMistakes[hand] || 0) + 1,
        }
        currentChartProgressToSet.mistakenHands = {
          ...mistakenHands,
          [hand]: (mistakenHands[hand] || 0) + 1,
        }
      }
      return {
        ...state,
        userStats: {
          ...state.userStats,
          [chartId]: {
            ...chartData,
            ...userStatsToSet,
          },
        },
        currentChartProgress: {
          ...state.currentChartProgress,
          [chartId]: currentChartProgressToSet,
        },
      }
    }

    case 'set-user-sweeper-stats': {
      const { userStats, currentChartProgress } = action.payload

      const currentChartProgressToSet = {}

      if (currentChartProgress) {
        const currentChartProgressData = currentChartProgress.reduce(
          (acc, curr) => {
            const { chart_id: chartId, mistaken_hands, completed_hands } = curr
            const completedHands = unescape(completed_hands)
            const mistakenHands = unescape(mistaken_hands)

            const chartData = {
              chartId,
              completedHands,
              mistakenHands,
            }
            return { ...acc, [chartId]: chartData }
          },
          {},
        )

        currentChartProgressToSet.currentChartProgress = currentChartProgressData
      }

      return {
        ...state,
        userStats,
        ...currentChartProgressToSet,
      }
    }
    default:
      return state
  }
}

const ClearTheChartsProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, defaultState)

  const value = { state, dispatch }
  return (
    <ClearTheChartsContext.Provider value={value}>
      {props.children}
    </ClearTheChartsContext.Provider>
  )
}

export { ClearTheChartsConsumer, ClearTheChartsProvider, ClearTheChartsContext }
